export default __webpack_public_path__ + "static/media/irsr.49e57e67.PNG";